import { AppRoutes } from "../../../../../constants";

export const OpenComplianceForm = (url: string) => {
    window.open(url, '_blank', 'noopener,noreferrer');
}